import { ErrorHandler, Injectable, Optional } from '@angular/core';
import { COMMIT_HASH } from '../version';

export type LogLevel = 'low' | 'medium' | 'high';

export interface LogEntry {
  ts:         number;   // Unix ms
  level:      LogLevel;
  version?:   string;
  className?: string;
  message:    string;
  stack?:     string;
}

const BUFFER_SIZE = 50;

@Injectable({ providedIn: 'root' })
export class ErrorLogService {

  private buffer: LogEntry[] = [];

  add(entry: LogEntry): void {
    const enriched = { ...entry, version: COMMIT_HASH };
    if (this.buffer.length >= BUFFER_SIZE) {
      this.buffer.shift();
    }
    this.buffer.push(enriched);
    this.send(enriched);
  }

  getAll(): LogEntry[] {
    return [...this.buffer];
  }

  private send(entry: LogEntry): void {
    try {
      fetch('/api/logs', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(entry),
        keepalive: true,
      }).catch(() => { /* swallow network errors */ });
    } catch { /* swallow */ }
  }
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private logs: ErrorLogService) {
    window.addEventListener('error', (ev) => {
      logs.add({
        ts:        Date.now(),
        level:     'high',
        className: 'window.onerror',
        message:   ev.message,
        stack:     ev.error?.stack ?? '',
      });
    });

    window.addEventListener('unhandledrejection', (ev) => {
      const reason = ev.reason;
      logs.add({
        ts:        Date.now(),
        level:     'high',
        className: 'UnhandledRejection',
        message:   reason?.message ?? String(reason),
        stack:     reason?.stack ?? '',
      });
    });
  }

  handleError(error: any): void {
    this.logs.add({
      ts:        Date.now(),
      level:     'high',
      className: 'GlobalErrorHandler',
      message:   error?.message ?? String(error),
      stack:     error?.stack ?? '',
    });
    console.error(error);
  }
}
